export enum CertificateStatus {
  ACTIVE = 'Active',
  EXPIRED = 'Expired',
}

export enum CertificateFeedbackStatus {
  RECEIVED = 'RECEIVED',
  ACCEPTED = 'ACCEPTED',
  REJECTED = 'REJECTED',
}

export enum CertificatePermissionReviewStatus {
  RECEIVED = 'Received',
  ACCEPTED = 'Accepted',
  REJECTED = 'Rejected',
}

// These 2 statuses are used for the consumerReviewStatus field in the GetSupplierCertificateDto. They represent the status of the consumer's review of the supplier's certificate permission request.
export enum RequestReviewStatus {
  REQUESTED = 'Requested',
  PENDING = 'Pending',
}

export enum CertificatePermissionType {
  PULL = 'Pull',
  PUSH = 'Push',
}

export enum CertificateSource {
  PUSHED = 'Pushed',
  REQUESTED = 'Requested',
}

export enum TrustLevel {
  NONE = 'none',
  LOW = 'low',
  MEDIUM = 'medium',
  HIGH = 'high',
  TRUSTED = 'trusted',
}

export type CertificateEnclosedSite = {
  id: number;
  bpns: string;
  name: string;
};

export type CertificateEnclosedSiteName = {
  name: string;
};

export interface ICertificate {
  id: number;
  type?: string;
  version?: string;
  registrationNumber?: string;
  documentId?: string;
  hasExpiry?: boolean;
  validFrom?: string;
  validUntil: string;
  appliesToAllSites?: boolean;
  enclosedSites?: CertificateEnclosedSite[];
  canEditEnclosedSites?: boolean;
  s3Path?: string;
  areaOfApplication?: string;
  assetId?: string;
  issuerName?: string;
  issuerBpn: string;
  validatorName?: string;
  validatorBpn?: string;
  trustLevel: TrustLevel;
  companyId?: number;
  userId?: number;
  companyName?: string;
  companyBpn?: string;
  dateCreated?: string;
  dateUpdated?: string;
  status?: CertificateStatus;
  consumerReviewStatus?: CertificatePermissionReviewStatus | RequestReviewStatus;
  reviewedBy?: string;
  received?: string;
}

export interface IMyCertificatesTableRow {
  id: number;
  type?: string;
  validUntil?: string;
  appliesToAllSites?: boolean;
  enclosedSites?: CertificateEnclosedSiteName[];
  status?: CertificateStatus;
}

export interface ISupplierCertificateError {
  message: string;
}

export interface ISupplierCertificatesTableRow {
  id: number;
  supplierName?: string;
  supplierBpn?: string;
  type?: string;
  validUntil?: string;
  received?: string;
  consumerReviewStatus?: CertificatePermissionReviewStatus | RequestReviewStatus;
  status?: CertificateStatus;
  source?: CertificateSource;
  reviewedBy?: {
    firstName?: string;
    lastName?: string;
  };
  errors?: ISupplierCertificateError[];
}

export interface ICertificatePermission {
  id: number;
  consumerCompanyBpn: string;
  consumerCompanyName: string;
  lastRetrieved?: string | null;
  consumerReviewStatus?: CertificatePermissionReviewStatus;
  type: CertificatePermissionType;
  dateCreated: string;
  approvedByUser?: {
    firstName?: string;
    lastName?: string;
  };
  certificate?: {
    id: number;
  };
}
